import Lenis from "lenis";

let instance = null;

export const startLenis = () => {
  instance = new Lenis({ duration: 1.25, smoothWheel: true });
  let raf;
  const loop = (t) => {
    instance.raf(t);
    raf = requestAnimationFrame(loop);
  };
  raf = requestAnimationFrame(loop);
  return () => {
    cancelAnimationFrame(raf);
    instance.destroy();
    instance = null;
  };
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (instance) {
    instance.resize();
    instance.scrollTo(el, { offset: id === "home" ? -200 : -72 });
  }
  else el.scrollIntoView({ behavior: "smooth" });
  el.focus({ preventScroll: true });
};
